import { render, staticRenderFns } from "./TopicDetailComment.vue?vue&type=template&id=001aaf7e&scoped=true&"
import script from "./TopicDetailComment.vue?vue&type=script&lang=ts&"
export * from "./TopicDetailComment.vue?vue&type=script&lang=ts&"
import style0 from "./TopicDetailComment.vue?vue&type=style&index=0&id=001aaf7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001aaf7e",
  null
  
)

export default component.exports